import { Component, Input, OnInit } from '@angular/core';
import { Gallery } from 'src/app/model/gallery';
import { GalleryService } from 'src/app/services/gallery.service';
import { ActivatedRoute } from '@angular/router';
import { GALLERY_IMAGE } from 'ngx-image-gallery';
import { ViewChild } from '@angular/core';
import { NgxImageGalleryComponent } from 'ngx-image-gallery';
import { GALLERY_CONF } from 'ngx-image-gallery';

@Component({
  selector: 'gallery',
  templateUrl: 'gallery.html'
})

export class GalleryComponent implements OnInit {
  @Input() gallery: Gallery;
  @ViewChild("gallery") ngxImageGallery: NgxImageGalleryComponent;

  // gallery configuration
  conf: GALLERY_CONF = {
    showCloseControl: false,
    showDeleteControl: false,
    showImageTitle: false,
    inline: true,
    backdropColor: "#FFFFFF",
    reactToRightClick: true
  };

  images: GALLERY_IMAGE[] = [];

  constructor(
    private readonly galleryService: GalleryService,
    private readonly route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const galleryId = this.route.snapshot.paramMap.get("id");
    this.galleryService.getGalleries().subscribe(galleries => {
      this.gallery = galleries.find(gallery => gallery.galleryId === galleryId);
      this.gallery.imageUrls.forEach(imageUrl => this.images.push({ url: imageUrl }));
    });
  }
}